// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__G5joX","tab":"styles_tab__3uinP","active":"styles_active__2aYTQ"};